// All yoga programs / courses offered by Yogarambh Wellness.
// Duration, level, schedule and priceNote are DUMMY values — edit freely.
// `image` paths point to files in /public/gallery (swap with your own anytime).

export const programs = [
  {
    slug: "prenatal-conceive",
    title: "Planning to Conceive & Prenatal",
    summary:
      "Gentle, trimester-wise yoga to prepare the body for conception and nurture a healthy pregnancy.",
    description:
      "A nurturing practice for women planning to conceive and expectant mothers across all trimesters. Sessions combine safe asanas, breathwork and deep relaxation to support hormonal balance, ease common discomforts and build the strength and calm needed through pregnancy.",
    duration: "60 min / session",
    level: "All levels · Beginner friendly",
    schedule: "Mon, Wed, Fri — mornings",
    highlights: [
      "Trimester-specific safe sequences",
      "Pelvic floor & breath awareness",
      "Relaxation for better sleep",
      "Guidance for every stage",
    ],
    image: "/gallery/side-bend.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "garbh-sanskar",
    title: "Garbh Sanskar",
    summary:
      "Holistic prenatal practice blending yoga, mantra and meditation for mother and baby.",
    description:
      "Rooted in Indian tradition, Garbh Sanskar combines asanas, pranayama, mantra chanting and meditation to create a calm, positive environment for the growing baby and an emotionally balanced experience for the mother.",
    duration: "60 min / session",
    level: "All levels",
    schedule: "Tue, Thu — mornings",
    highlights: [
      "Mantra & sound for the baby",
      "Mindful breathing",
      "Emotional well-being",
      "Bonding meditations",
    ],
    image: "/gallery/nourish.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "postnatal",
    title: "Postnatal Yoga",
    summary:
      "Rebuild strength, restore posture and recover energy gently after childbirth.",
    description:
      "A restorative programme designed for new mothers. Focused on rebuilding core and pelvic floor strength, easing back and shoulder tension from feeding and carrying, and restoring energy and emotional balance at a comfortable pace.",
    duration: "60 min / session",
    level: "Beginner friendly",
    schedule: "Mon, Wed — late mornings",
    highlights: [
      "Core & pelvic floor recovery",
      "Posture correction",
      "Stress & fatigue relief",
      "Gentle progression",
    ],
    image: "/gallery/side-plank.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "kids-yoga",
    title: "Kids Yoga",
    summary:
      "Playful, story-led yoga that builds focus, flexibility and confidence in children.",
    description:
      "Fun, age-appropriate sessions that introduce children to yoga through play, stories and games. Builds strength, flexibility, concentration and emotional regulation while keeping the joy of movement alive. Led by a certified Kids Yoga Instructor.",
    duration: "45 min / session",
    level: "Ages 4–12",
    schedule: "Sat & Sun — mornings",
    highlights: [
      "Story & game based",
      "Focus & concentration",
      "Confidence building",
      "Certified kids instructor",
    ],
    image: "/gallery/kids-meditation.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "family-yoga",
    title: "Family Yoga",
    summary:
      "Practice together — a joyful shared session for parents and children.",
    description:
      "Bring the whole family to the mat. These sessions blend partner poses, breathing and relaxation that everyone can enjoy together, strengthening bonds while building a shared habit of wellness.",
    duration: "60 min / session",
    level: "All ages",
    schedule: "Sun — mornings",
    highlights: [
      "Partner & group poses",
      "Bonding through movement",
      "Fun for all ages",
      "Shared relaxation",
    ],
    image: "/gallery/namaskarasana.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "corporate-yoga",
    title: "Corporate Yoga",
    summary:
      "On-site or online sessions to reduce stress and boost team well-being.",
    description:
      "Tailored workplace wellness for teams and organisations. Desk-friendly stretches, breathing techniques and guided relaxation that reduce stress, improve focus and energy, and support a healthier, happier workforce. Available on-site and online.",
    duration: "45–60 min / session",
    level: "All levels",
    schedule: "Weekdays — flexible slots",
    highlights: [
      "Desk-friendly sequences",
      "Stress & burnout relief",
      "Team sessions",
      "On-site or online",
    ],
    image: "/gallery/tadasana.jpg",
    priceNote: "custom quote — contact us",
  },
  {
    slug: "yoga-for-women",
    title: "Yoga for Women",
    summary:
      "Yoga tuned to women's health — hormones, energy and emotional balance.",
    description:
      "A practice designed around women's wellness at every stage of life. Supports hormonal balance, menstrual and menopausal health, strength and flexibility, and emotional steadiness through asanas, pranayama and meditation.",
    duration: "60 min / session",
    level: "All levels",
    schedule: "Tue, Thu, Sat — mornings",
    highlights: [
      "Hormonal balance",
      "Strength & flexibility",
      "Emotional well-being",
      "All life stages",
    ],
    image: "/gallery/om-mantra.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "sedentary-lifestyle",
    title: "Yoga for Sedentary Lifestyle",
    summary:
      "For desk professionals (6+ hrs sitting) — undo stiffness and restore mobility.",
    description:
      "Targeted at people with long desk hours (6+ hours a day). Releases tightness in the neck, shoulders, hips and lower back, improves posture and circulation, and rebuilds mobility and energy lost to prolonged sitting.",
    duration: "45–60 min / session",
    level: "Beginner friendly",
    schedule: "Evenings — weekdays",
    highlights: [
      "Neck, shoulder & back relief",
      "Posture & mobility",
      "Energy & circulation",
      "Easy to follow",
    ],
    image: "/gallery/side-bend.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "yoga-for-seniors",
    title: "Yoga for Seniors",
    summary:
      "Safe, gentle yoga to keep joints supple, balance steady and the mind calm.",
    description:
      "Accessible, gentle sessions for older adults. Improves joint mobility, balance and flexibility while supporting circulation, breathing and relaxation. Modifications and chair support available so everyone can practise safely.",
    duration: "45 min / session",
    level: "Gentle · Beginner friendly",
    schedule: "Mon, Wed, Fri — mornings",
    highlights: [
      "Joint mobility & balance",
      "Chair & wall support",
      "Gentle breathwork",
      "Calm & relaxation",
    ],
    image: "/gallery/nourish.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "yoga-for-teens",
    title: "Yoga for Teens",
    summary:
      "Help teens manage stress, focus better and build a positive body image.",
    description:
      "Designed for the teenage years — managing academic stress and anxiety, improving focus and sleep, and building strength, flexibility and a healthy relationship with the body and mind.",
    duration: "60 min / session",
    level: "Ages 13–18",
    schedule: "Sat — afternoons",
    highlights: [
      "Stress & exam anxiety relief",
      "Focus & sleep",
      "Strength & flexibility",
      "Body positivity",
    ],
    image: "/gallery/tadasana.jpg",
    priceNote: "from a Monthly plan",
  },
  {
    slug: "yoga-for-adults",
    title: "Yoga for Adults",
    summary:
      "A complete, all-round practice for strength, flexibility and inner calm.",
    description:
      "A well-rounded practice for adults of all levels. Combines asanas, pranayama, meditation and relaxation to build strength and flexibility, manage stress, and create harmony between body, mind and emotions.",
    duration: "60 min / session",
    level: "All levels",
    schedule: "Daily — multiple slots",
    highlights: [
      "Strength & flexibility",
      "Breath & meditation",
      "Stress management",
      "Mind-body harmony",
    ],
    image: "/gallery/side-plank.jpg",
    priceNote: "from a Monthly plan",
  },
];

export const getProgram = (slug) => programs.find((p) => p.slug === slug);

export default programs;
